const AUTOFILL_ANIMATION_NAME = 'cashierAutofillStart';
const AUTOFILL_TARGET_SELECTOR = '.input';

const clearAutofillBackground = (input) => {
    if (!input || typeof input.value === 'undefined') {
        return;
    }
    const value = input.value;
    input.value = '';
    input.value = value;
};

const initAutofillBackgroundFix = () => {
    if (typeof window === 'undefined' || window.__cashierAutofillFixInitialized) {
        return;
    }
    window.__cashierAutofillFixInitialized = true;

    const style = document.createElement('style');
    style.textContent =
        '@keyframes ' + AUTOFILL_ANIMATION_NAME + ' { from {} to {} }' +
        AUTOFILL_TARGET_SELECTOR + ':-webkit-autofill {' +
        ' animation-name: ' + AUTOFILL_ANIMATION_NAME + '; animation-duration: 1ms; }';
    (document.head || document.documentElement).appendChild(style);

    document.addEventListener('animationstart', (event) => {
        if (event.animationName !== AUTOFILL_ANIMATION_NAME) {
            return;
        }
        const input = event.target;
        if (!input || input.tagName !== 'INPUT') {
            return;
        }
        requestAnimationFrame(() => {
            clearAutofillBackground(input);
        });
    }, true);
};

export default initAutofillBackgroundFix;
